import { createApi, fetchBaseQuery } from "@reduxjs/toolkit/query/react";
import { AUTH_URL } from "../../util/constants";

export const docsApi = createApi({
	reducerPath: "docsApi",
	baseQuery: fetchBaseQuery({
		baseUrl: AUTH_URL,
	}),
	tagTypes: ["uploadCompanyDocs", "getDocs", "deleteComapnyDoc"],
	endpoints: (builder) => ({
		uploadCompanyDoc: builder.mutation<any, { data: any }>({
			query: ({ data }) => ({
				url: "/upload",
				method: "POST",
				body: data,
				credentials: "include"
			}),
			invalidatesTags: ["getDocs", "deleteComapnyDoc"]
		}),
		getCompanyDocs: builder.query<any, void>({
			query: () => ({
				url: "/companyPolicies",
				credentials: "include"
			}),
			providesTags: ["getDocs", "deleteComapnyDoc"]
		}),
		deleteCompanyDoc: builder.mutation<
			any,
			{ fileKey: string | undefined | null }
		>({
			query: ({ fileKey }) => ({
				url: `/deleteDoc/?id=${fileKey}`,
				method: "DELETE",
				body: fileKey,
				credentials: "include"
			}),
			invalidatesTags: ["getDocs", "uploadCompanyDocs"]
		})
	})
});

export const {
	useGetCompanyDocsQuery,
	useUploadCompanyDocMutation,
	useDeleteCompanyDocMutation
} = docsApi;
